import * as React from 'react';

import { PageTitleBar } from 'components';

const PublicNoticesHeader = () => (
  <PageTitleBar showBackButton={false} headerTitle='اطلاع‌رسانی عمومی' />
);

export { PublicNoticesHeader };
